var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "maintenance-shell" }, [
    _c("div", { staticClass: "aurora aurora-a" }),
    _c("div", { staticClass: "aurora aurora-b" }),
    _c("div", { staticClass: "grid" }),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "badge" }, [
        _vm._v("Scheduled Platform Tune-Up"),
      ]),
      _c("h1", [_vm._v("We are polishing CASS")]),
      _vm._m(0),
      _c("div", { staticClass: "game-panel" }, [
        _c("div", { staticClass: "game-head" }, [
          _c("span", [_vm._v("Route Runner")]),
          _c("span", [_vm._v("Score " + _vm._s(_vm.displayScore))]),
          _c("span", [_vm._v("Best " + _vm._s(_vm.bestScore))]),
        ]),
        _vm._m(1),
        _c("div", { ref: "gameArea", staticClass: "canvas-wrap" }, [
          _c("canvas", { ref: "gameCanvas", staticClass: "game-canvas" }),
          !_vm.running
            ? _c(
                "div",
                { staticClass: "overlay" },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.gameOver ? "Incident detected" : "Ready to run"
                      )
                    ),
                  ]),
                  _vm.gameOver
                    ? _c("p", [
                        _vm._v(
                          _vm._s(_vm.gameOverReason) +
                            ". Final score " +
                            _vm._s(_vm.displayScore)
                        ),
                      ])
                    : _c("p", [
                        _vm._v(
                          "You are a REQ packet. Jump outages, duck firewalls, collect 200 OK."
                        ),
                      ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#006c27", dark: "" },
                      on: { click: _vm.startGame },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.gameOver ? "Play Again" : "Start") +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "controls-row" }, [
          _c("div", { staticClass: "desktop-hint" }, [
            _vm._v("Desktop: Space/Up to jump, Down to duck."),
          ]),
          _c(
            "div",
            { staticClass: "mobile-controls" },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", outlined: "", color: "#fbc02d" },
                  on: {
                    touchstart: function ($event) {
                      $event.preventDefault()
                      return _vm.setDuck(true)
                    },
                    touchend: function ($event) {
                      $event.preventDefault()
                      return _vm.setDuck(false)
                    },
                    mousedown: function ($event) {
                      $event.preventDefault()
                      return _vm.setDuck(true)
                    },
                    mouseup: function ($event) {
                      $event.preventDefault()
                      return _vm.setDuck(false)
                    },
                    mouseleave: function ($event) {
                      return _vm.setDuck(false)
                    },
                  },
                },
                [_vm._v(" Duck ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { small: "", outlined: "", color: "#66bb6a" },
                  on: {
                    touchstart: function ($event) {
                      $event.preventDefault()
                      return _vm.jump.apply(null, arguments)
                    },
                    mousedown: function ($event) {
                      $event.preventDefault()
                      return _vm.jump.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" Jump ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "hint" }, [
        _vm._v("Please close this tab and come back later."),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "subtitle" }, [
      _vm._v(
        " Maintenance mode is active. While we are working, try a quick round of "
      ),
      _c("strong", [_vm._v("Route Runner")]),
      _vm._v(". "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "legend-row" }, [
      _c("span", { staticClass: "legend-item legend-player" }, [
        _vm._v("REQ packet: you"),
      ]),
      _c("span", { staticClass: "legend-item legend-outage" }, [
        _vm._v("503 barrier: jump"),
      ]),
      _c("span", { staticClass: "legend-item legend-firewall" }, [
        _vm._v("firewall gate: duck"),
      ]),
      _c("span", { staticClass: "legend-item legend-token" }, [
        _vm._v("200 OK token: collect"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }